import Promise from 'promise-polyfill'

if (!window.Promise) {
  window.Promise = Promise
}



// WEBPACK FOOTER //
// ./src/promise.js